<template>
  <div :data-testid="dataTestid" class="flex flex-col items-center gap-4 py-6 text-center text-subtlest">
    <div class="w-56 space-y-1.5" aria-hidden="true">
      <div v-for="bar in GHOST_BARS" :key="bar" class="h-3 rounded-sm bg-surface-elevation-2" :class="bar" />
    </div>
    <div class="max-w-72">
      <p :data-testid="dataTestid ? `${dataTestid}-title` : undefined" class="txt-body-s-semibold">
        {{ t(`Reviews.product.insights.state.${STATE_KEYS[state]}.title`) }}
      </p>
      <p :data-testid="dataTestid ? `${dataTestid}-body` : undefined" class="txt-body-s-regular">
        {{ t(`Reviews.product.insights.state.${STATE_KEYS[state]}.body`) }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { STATE_KEYS, type InsightsEmptyMetricState } from '@/gql/reviews/mappers/insights/insightsState'

withDefaults(
  defineProps<{
    state: InsightsEmptyMetricState
    dataTestid?: string
  }>(),
  { dataTestid: undefined },
)

const GHOST_BARS = ['w-full opacity-75', 'w-2/3 opacity-50', 'w-1/3 opacity-25']

const { t } = useI18n()
</script>
